import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { featchIdcardList } from './thunk'

/**
 * @interface
 */
const initialState = {
    loading: 'idle',
    entities: null,
    totalCount: 0,
    pagination: {
        page: 1,
        sizePerPage: 10
    },
    filters: {
        structureId: '',
        training: 'Todos'
    }
}

export const idcardSlice = createSlice({
    name: 'idcard',
    initialState,
    reducers: {
        changePagination: (state, { payload }) => {
            state.pagination = payload
        },
        setIdCardFilters: (state, { payload }) => {
            state.filters = payload
        },
        clearIdCardFilters: (state, { payload }) => {
            state.filters = {}
        },
    },
    extraReducers: build => {
        build
            .addCase(featchIdcardList.pending, (state, { payload }) => {
                if ( state.loading === 'idle' ) {
                    state.loading = 'loading'
                }
            })
            .addCase(featchIdcardList.rejected, (state, { payload }) => {
                state.loading = 'idle'
            })
            .addCase(featchIdcardList.fulfilled, ( state, { payload }) => {
                if ( state.loading === 'loading' ) {
                    state.loading = 'idle'
                    state.entities = payload.entities
                    state.totalCount = payload.total
                }
            })
    }
})

// Export the actions
export const {
    changePagination,
    clearIdCardFilters,
    setIdCardFilters,
} = idcardSlice.actions

/**
 * 
 * @returns {initialState}
 */
export const useSelectIdCard = () => useSelector(state => state.idcard );

// Export reducer as default
export default idcardSlice.reducer